// Remappable gamepad bindings — works with ANY controller, standard-mapped or
// not. Defaults to the Web "standard" (Xbox) layout so well-behaved pads work
// out of the box; the Controller Setup wizard (ui/controllerSetup.js) overwrites
// each button/axis to whatever the player's pad actually reports, and persists
// it to localStorage.
//
// Axis bindings store an index + a sign multiplier so we can normalize "right"
// and "down" to positive regardless of how the pad reports them.

const KEY = 'mao.gamepad.bindings.v1'

export const DEFAULTS = Object.freeze({
  // Movement stick.
  moveX: 0, moveXInv: 1,
  moveY: 1, moveYInv: 1,
  // Pointer (cursor) stick.
  pointerX: 2, pointerXInv: 1,
  pointerY: 3, pointerYInv: 1,
  // Action buttons (standard Xbox indices).
  tend: 0,        // A — tap / click UI
  toolCare: 2,    // X — citizen-care tool
  toolDefense: 3, // Y — defense / aim tool
  rotateL: 4,     // LB
  rotateR: 5,     // RB
  pause: 9,       // Start
  recall: 8,      // Back/Select
  cancel: 1,      // B — Escape / cancel
})

// The order + labels the setup wizard walks through.
export const SETUP_STEPS = [
  { type: 'axisRight', group: 'move',    label: 'Push your MOVE stick fully RIGHT →' },
  { type: 'axisDown',  group: 'move',    label: 'Now push your MOVE stick fully DOWN ↓' },
  { type: 'button',    key: 'tend',      label: 'Press the button to TEND / tap (your main action)' },
  { type: 'button',    key: 'toolCare',  label: 'Press the button for the CITIZEN-CARE tool' },
  { type: 'button',    key: 'toolDefense', label: 'Press the button for the DEFENSE / aim tool' },
  { type: 'button',    key: 'pause',     label: 'Press the button to PAUSE' },
  { type: 'button',    key: 'recall',    label: 'Press the button to RECALL HOME' },
  { type: 'button',    key: 'rotateL',   label: 'Press the button to ROTATE VIEW LEFT' },
  { type: 'button',    key: 'rotateR',   label: 'Press the button to ROTATE VIEW RIGHT' },
  { type: 'axisRight', group: 'pointer', label: 'Push your POINTER stick (the other one) RIGHT →' },
  { type: 'axisDown',  group: 'pointer', label: 'Now push your POINTER stick DOWN ↓' },
  { type: 'button',    key: 'cancel',    label: 'Press the button for BACK / cancel' },
]

let bindings = load()
let capturing = false // true while the setup wizard owns the pad (suspends game input)

function load() {
  try { return { ...DEFAULTS, ...JSON.parse(localStorage.getItem(KEY) || '{}') } }
  catch { return { ...DEFAULTS } }
}

export function getBindings() { return bindings }
export function saveBindings(next) {
  bindings = { ...DEFAULTS, ...next }
  try { localStorage.setItem(KEY, JSON.stringify(bindings)) } catch { /* private mode */ }
}
export function resetBindings() {
  bindings = { ...DEFAULTS }
  try { localStorage.removeItem(KEY) } catch { /* ignore */ }
}
export function isConfigured() {
  try { return !!localStorage.getItem(KEY) } catch { return false }
}

// While true, heroController + gamepadCursor pause their polling so presses
// during setup bind instead of firing game actions.
export function isCapturing() { return capturing }
export function setCapturing(v) { capturing = !!v }
